import { IBlockCardsProduct, IBlockCardsProductBO } from '../../../components/block-cards-product/block-cards-product';
import { LinkPresenter } from '../../commons/link.presenter';
import { MediaImagePresenter } from '../../commons/media-image.presenter';
import { IBlockPresenter } from '../../presenter';

export class BlockCardsProductPresenter implements IBlockPresenter {
  parse(data: IBlockCardsProductBO): IBlockCardsProduct {
    if (!data) {
      return null;
    }

    return {
      __typename: data.__typename,
      title: data.title,
      chapo: data.chapo,
      products: data.products.map(product => ({
        id: product.entity.nid.toString(),
        name: product.entity.title,
        description: product.entity.description.processed,
        logo: MediaImagePresenter.getImageWebp(product.entity.logo),
        image: MediaImagePresenter.getCoverWithWebp(product.entity.image),
        price: +product.entity.price,
        ctaUrl: LinkPresenter.getLink(product.entity.CTAUrl),
      })),
    };
  }
}
